export default __webpack_public_path__ + "static/media/FlexeetLogoCyan.f18adc37.svg";